import React from 'react'

export const FundingView = () => {
  return (
    <div>Funding Page</div>
  )
}
